<template>
  <div class="main-conent main-conent-maxheight main-content-rows">
    <div class="main-content-cols">
      <side-menu
        v-if="metes.length > 1"
        :menus="menus"
        :loading="loading"
        :actived="actived"
        @change="deviceChange"
      ></side-menu>

      <div class="main-content-cols__body" v-loading="loading">
        <carousel :loading="loadingCols" :data="curData"></carousel>

        <search
          @date-change="dateChange"
          @type-change="typeChange"
          @export="exportExcel"
        ></search>

        <el-row v-show="type === 'preview'" :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-table
              v-if="reload"
              size="small"
              stripe
              border
              :data="analysis"
              :height="380"
            >
              <el-table-column prop="name" label="传感器"></el-table-column>
              <el-table-column prop="avg" label="平均"></el-table-column>
              <el-table-column prop="min" label="最小"></el-table-column>
              <el-table-column prop="max" label="最大"></el-table-column>
            </el-table>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
            <div class="box-card">
              <echart
                v-if="reload"
                chartId="meteorology"
                :options="options"
                :height="340"
                :notMerge="true"
              ></echart>
            </div>
          </el-col>
        </el-row>

        <el-row v-show="type === 'data'" :gutter="20">
          <el-col>
            <data-list
              v-if="reload"
              v-loading="loading"
              ref="table"
              :cols="cols"
              :data="options.dataset.source"
              :height="height"
            ></data-list>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Echart from '@/components/Chart'
import SideMenu from '@/components/MainSideMenu'
import DataList from './components/dataList'
import Carousel from './components/list'
import Search from './components/search'
import { list, cols } from '@/service/meteorology'
import { getIcon } from '@/utlis/meteorology'
import sleep from '@/utlis/sleep'

export default {
  components: { Carousel, SideMenu, Echart, DataList, Search },
  data() {
    return {
      loadingCols: false, // 初始化列数据
      loading: false,
      reload: true, // 用于刷新 el-table 高度
      actived: 0,
      type: 'preview', // 显示的类型
      menus: [],
      cols: [],
      curData: [],
      height: 600,
      query: {
        begin: moment().format('YYYY-MM-DD 00:00:00'),
        end: moment().format('YYYY-MM-DD 23:59:59')
      }, // 查询参数。用于在设备切换时保留查询参数
      analysis: [],
      options: {
        legend: {
          textStyle: { fontSize: 14 },
          type: 'scroll',
          left: '10%',
          right: '6%',
          pageButtonGap: 20,
          selectedMode: 'single',
          top: '16px'
        },
        tooltip: {
          transitionDuration: 0
        },
        grid: {
          top: 80,
          right: '4%',
          bottom: 20
        },
        xAxis: {
          type: 'category',
          boundaryGap: false
        },
        yAxis: {
          type: 'value'
        },
        dataset: { source: [] },
        series: []
      }
    }
  },
  computed: {
    deviceId() {
      if (!this.metes.length) return 0
      let device = this.metes[this.actived]
      return device && device.id
    }
  },
  async mounted() {
    this.height = this.$el.offsetHeight - 118 - 93 - 60
    this.menus = this.metes.map(m => ({ title: m.name }))
    await this.getCols()
    this.initData()
  },
  methods: {
    async getCols() {
      this.loadingCols = true
      const { data } = await cols(this.deviceId)
      this.cols = data
      this.loadingCols = false
    },
    async initData() {
      this.loading = true

      const { begin, end, type } = this.query
      const [oriData, curData] = await Promise.all([
        this.getData(begin, end, type),
        this.getCurData(),
        sleep(1)
      ])

      this.curData = curData
      this.options = { ...this.options, ...oriData }
      this.loading = false
    },
    async getData(begin, end, type = 'day') {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        begin,
        end,
        type
      })
      const keys = this.cols.filter(c => !['lng', 'lon', 'lat'].includes(c.key))
      this.analysis = keys.map(k => this.getAnalysis(k, data))

      return {
        dataset: {
          dimensions: ['date'].concat(keys.map(c => c.key)),
          source: data
        },
        series: keys.map(k => this.getSeries(k))
      }
    },
    async getCurData() {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        type: 'last'
      })
      return this.cols.map(c => {
        let icon = getIcon(c.name)
        return {
          ...c,
          icon: icon.icon,
          color: icon.color,
          value: data[c.key] || '-'
        }
      })
    },
    async dateChange(begin, end, type) {
      this.loading = true
      const data = await this.getData(begin, end, type)
      this.options = { ...this.options, ...data }
      this.query = { begin, end, type }
      this.loading = false
    },
    async deviceChange(actived) {
      this.actived = actived
      await this.getCols()
      this.initData()
    },
    typeChange(type) {
      this.type = type
    },
    exportExcel(title) {
      this.$refs.table.exportExcel(title)
    },
    getAnalysis(el, data) {
      let { sum, min, max } = data.reduce(
        (result, item) => {
          let sum = result.sum + item[el.key]
          return {
            sum,
            min: result.min ? Math.min(result.min, item[el.key]) : item[el.key],
            max: Math.max(result.max, item[el.key])
          }
        },
        { sum: 0, min: 0, max: 0 }
      )
      return {
        name: el.name,
        avg: data.length ? Math.round((sum / data.length) * 100) / 100 : '-',
        min,
        max
      }
    },
    getSeries({ name, key }) {
      let lines = []

      if (+this.companyId === 29) {
        if (key.includes('soilh')) {
          lines = lines.concat([{ yAxis: 20 }, { yAxis: 40 }])
        } else if (key.includes('soilt')) {
          lines = lines.concat([{ yAxis: 12 }, { yAxis: 26 }])
        } else if (key === 'sunL') {
          lines = lines.concat([{ yAxis: 2.6 }, { yAxis: 40 }])
        } else if (key === 'airT') {
          lines = lines.concat([{ yAxis: 12 }, { yAxis: 25 }])
        } else if (key === 'airH') {
          lines = lines.concat([{ yAxis: 50 }, { yAxis: 80 }])
        }
      }
      return {
        type: 'line',
        name,
        markPoint: {
          data: [
            { type: 'max', name: '最大值', itemStyle: { color: '#ee6666' } },
            { type: 'min', name: '最小值', itemStyle: { color: '#3ba272' } }
          ]
        },
        markLine: {
          silent: true,
          lineStyle: { color: 'rgb(255, 0, 0)' },
          data: lines
        }
      }
    }
  },
  watch: {
    // 监控高度刷新 el-table 高度
    height() {
      this.reload = false
      this.$nextTick(() => {
        this.reload = true
      })
    }
  }
}
</script>

<style lang="scss">
.mete-data-container {
  height: 100%;
}
</style>
